export function loadStripeJs() {
  // Define your publishable keys
  const TEST_KEY = 'pk_test_51QjXwxA45BP9HTIakPvJeeegKrmH3qBm28H9P3oc9ooI76iN7SUeYzsWCSxCgqeHrboafYoEfZ8s2ys9scKpaOnN00Kj2XTSM5';
  const LIVE_KEY = 'pk_live_51QjXwxA45BP9HTIafAY1Akla7WMtESTr38XX2mOYEIDvs5U71ZUExKZrXjCeasmwSbKgeo0YCE9MlPt3pB3oqetC00El7ur4yR';

  // Use test key for localhost or *.dev domains, otherwise live
  const isTest =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1' ||
      window.location.hostname.endsWith('.dev'));
  const key = isTest ? TEST_KEY : LIVE_KEY;

  return new Promise((resolve, reject) => {
    if (window.Stripe) {
      resolve(window.Stripe(key));
    } else {
      const script = document.createElement('script');
      script.src = 'https://js.stripe.com/v3/';
      script.onload = () => resolve(window.Stripe(key));
      script.onerror = reject;
      document.body.appendChild(script);
    }
  });
} 